import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AlertMessage({ variant, children }) {
    const variantStyles = {
        error: 'bg-red-50 border-red-200 text-red-600',
        success: 'bg-green-50 border-green-200 text-green-600',
        info: 'bg-blue-50 border-blue-200 text-blue-800'
    };
    const icon = {
        error: 'Error:',
        success: '✓',
        info: '💡'
    };
    return /*#__PURE__*/ _jsx("div", {
        className: `border rounded-md p-4 mb-6 ${variantStyles[variant]}`,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "font-medium",
                    children: icon[variant]
                }),
                " ",
                children
            ]
        })
    });
}
